// extracted by mini-css-extract-plugin
export default {"input":"styles_input__JT7We"};